export default __webpack_public_path__ + "static/media/slider2.bd92752a.png";